"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalType = void 0;
var PortalType;
(function (PortalType) {
    PortalType["MASTER"] = "master";
    PortalType["BACHELOR"] = "bachelor";
    PortalType["PHD"] = "phd";
    PortalType["SHORT"] = "short";
    PortalType["DISTANCE_LEARNING"] = "distance_learning";
})(PortalType = exports.PortalType || (exports.PortalType = {}));
//# sourceMappingURL=portal-type.js.map